if (!customElements.get('video-slider')) {
  customElements.define(
    'video-slider',
    class ProductSlider extends HTMLElement {
      connectedCallback() {
        const swiper = new Swiper('.swiper-container', {
          loop: false,
          spaceBetween: 20,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            640: {
              slidesPerView: 1.6,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2.1,
              spaceBetween: 20,
            },
            1600: {
              slidesPerView: 4,
              spaceBetween: 20
            },
          },
        });
      }
    }
  );
}